module.exports = __webpack_public_path__ + "img/sceneIcon2-3.e3d2cdf7.png";